module.exports = __webpack_public_path__ + "static/media/Mic32RegularRegular.12fbfd67.ttf";